module.exports = __webpack_public_path__ + "img/Frame_05.dcb1d93c.png";